module.exports = __webpack_public_path__ + "img/new-produtos.fdb728e1.svg";